import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/redux';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-gray-border"></div>
      </div>
    );
  }

  if (!isAuthenticated) { // todo: check user authenticated 
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}